export const en = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>Film Directed by <strong>Mohammad Gorjestani</strong> & <strong>Andrew Batista</strong> Photography by <strong>Ike Edeani</strong></p>`
    },
    {
      template: 'leadModule',
      body: `“I don’t think Jesus had a social security number. He was a refugee. He fled from the same circumstances so many people flee today.”`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 524,
        height: 698,
        url: 'assets/images/story/story-cesar/cesar-side-image1.jpg',
        alt: 'Cesar on a busy sidewalk in downtown Nashville'
      },
      text: `<p>
                Faith is a huge part of Cesar Virto’s life—it guides him during uncertain times. Cesar was born in Mexico and was brought to Alabama at the age of three. He’s a homeowner, businessman, writer, and Lyft driver. Life in America is all he knows. But when he found out he was undocumented as a young man, life in America became nothing but uncertainty. 
            </p>
            <p>
                “I was sixteen, in driver’s ed class. And the school took me out, saying I wasn’t eligible to get a driver’s license. That’s how I found out I was undocumented. And when I started doing research about being undocumented, I realized that all those dreams had nine numbers—going to college, getting scholarships...all that required a social security number.”
            </p>
            <p>
                Cesar stayed angry. He rebelled. His grades dropped. “The teachers would ask me why I wasn’t trying, and I would say, ‘Okay, if I try, what happens? I could go to college? No, that’s for white people.’ And that’s it. I just stopped caring.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery1-1.jpg',
          alt: 'Cesar standing outside a church',
          index: '01',
          caption: `<p>Cesar is regularly invited to speak at other churches to tell his story.</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery1-2.jpg',
          alt: 'Cesar holding a bible',
          index: '02',
          caption: `<p>Cesar believes, "Christianity is for everyone."</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `I get messages from pastors telling me that I’m living in sin, that I shouldn’t be preaching or speaking God's word because I’m undocumented.`,
      cite: 'Cesar'
    },
    {
      template: 'textModule',
      text: `<p>
                After he was caught vandalizing a home with a friend, Cesar caught a break: instead of pressing charges, the homeowners, an older couple, requested that he make things right by helping them with yard work. This led to an unlikely friendship, and soon Cesar was attending church with them. As he puts it: “That’s how I was ushered into Christianity.” He remains a churchgoer today.
            </p>
            <p>
                His faith has been tested over the years. He has been both supported and reviled by his Christian community: church members chipped in to pay his tuition at a Bible college, whereas others have written him privately to tell him he should return to Mexico. “They would say, ‘Hey, you should just come back in the right way. You’re living in sin.’ That’s my own religion telling me I'm not good enough for it.”
            </p>
            <p>
                Cesar isn’t cowed. He has gone public with his undocumented all-American story, writing and speaking in support of the Deferred Action for Childhood Arrivals (DACA) program, of which he is a recipient. DACA has allowed Cesar and thousands of others who were brought, undocumented, to the United States by their parents to stay, work, and thrive here—and it could be repealed at any moment.
            </p>
            <p>
                Cesar fills his daily uncertainty with a kind of forward momentum, speaking regularly about his situation and immigration at churches, if they’ll have him. He’s never forgotten that he, once, was looked after; guided by his faith, he tries to do the same for others. “I don't think God put me in a position so I can look down on my own people,” he says. “My role is to be a bridge between Hispanics and Americans.”
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery2-1.jpg',
          alt: 'Cesar and his friends enjoy a drink outside on a summer afternoon',
          index: '01',
          caption: `<p>Cesar enjoying a summer evening with friends.</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery2-2.jpg',
          alt: 'Cesar at a bar with a large American flag behind him',
          index: '02',
          caption: `<p>Cesar describes, "When I'm driving with my windows down, or just taking some sweet tea in a mason jar, I feel American, just like anybody else."</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'I feel like an Alabama football fan. They have season tickets, their man-cave is full of ’Bama stuff, but most of them don’t have an Alabama degree. I have everything American: I have a house, I have a car, a great job, but I just don’t have that diploma—that citizenship.',
      cite: 'Cesar'
    },
    {
      template: 'textModule',
      text: `<p>Neither Cesar nor any other DACA recipient knows what will become of the program or their lives—and homes, and jobs, and families—in America. In the meantime, Cesar finally got his license, allowing him to drive legally. “As soon as I got it, I drove to see a friend in Florida, six hours away, and I just remember just crying like a baby and feeling like all this weight that I was bearing for the longest time was just falling away with every mile.”</p>`
    },
    {
      template: 'donateModule',
      title: 'Make a Donation',
      subtitle: 'And join our efforts',
      body: `<p> 
                Every issue contributing to our current immigration crisis is interconnected. Your stories inspire us to continue to take a stand — when our community of riders and drivers is threatened, we’re encouraged to take action.  
                <br><br>
                In honor of Cesar, we are humbled to support <a href="https://www.fwd.us/" target="_blank">FWD.us</a> — a bipartisan political organization that believes America’s families, communities, and economy thrive when more individuals are able to achieve their full potential. FWD.us advocates to protect the rights of DACA recipients, TPS holders, and DED holders.
                <br><br>
                Please join us in supporting them.
             </p>`,
      cta: 'Make a donation',
      url: 'http://bit.ly/FundDACA'
    },
    {
      template: 'nextStoryModule',
      id: 'story-shervin',
      title: `The '80s`,
      alt: 'Shervin sitting on his car',
      location: 'San Jose, CA',
      description: 'After the Iranian Revolution',
      imageSize1URL: 'assets/images/carousel/carousel-image-shervin-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-shervin-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700809.sd.mp4?s=03f44317b238802fa65f0cb857694e4651bb0be3&profile_id=165'
    }
  ]
};

export const es = {
  modules: [
    {
      template: 'authorModule',
      text: `<p>Video dirigido por <strong>Mohammad Gorjestani</strong> y <strong>Andrew Batista</strong> Fotografía de <strong>Ike Edeani</strong></p>`
    },
    {
      template: 'leadModule',
      body: `“No creo que Jesús tuviera un número de seguridad social. Él era un refugiado. Huyó de las mismas circunstancias de las que tanta gente huye hoy.”`
    },
    {
      template: 'textModule',
      leftImage: {
        width: 524,
        height: 698,
        url: 'assets/images/story/story-cesar/cesar-side-image1.jpg',
        alt: 'César en una acera concurrida en el centro de Nashville'
      },
      text: `<p>
                La fe es una parte importante de la vida de César Virto: lo guía en tiempos inciertos. César nació en México y fue llevado a Alabama cuando tenía tres años. Está casado, es propietario de una casa, empresario, escritor y conductor de Lyft. La vida en los Estados Unidos es todo lo que conoce, pero cuando descubrió que era un joven indocumentado, la vida en Estados Unidos se convirtió en pura incertidumbre. 
            </p>
            <p>
                "Tenía dieciséis años, en las clases de manejo. Y la escuela me expulsó diciendo que no era elegible para obtener una licencia de manejo. Así fue como descubrí que era indocumentado. Y cuando empecé a investigar sobre ser indocumentado, me di cuenta de que todos esos sueños tenían nueve números: ir a la universidad, obtener becas... todo aquello que requería un número de seguridad social".
            </p>
            <p>
                César se enojó. Mucho. Se rebeló. Sus calificaciones bajaron. "Los maestros me preguntaban por qué no lo intentaba y yo decía: 'Está bien, y si lo intento, ¿qué pasa? ¿Puedo ir a la universidad? No, eso es para la gente blanca". Y así fue. Me dejé de preocupar".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery1-1.jpg',
          alt: 'César parado afuera de una iglesia',
          index: '01',
          caption: `<p>A César lo invitan a menudo a hablar en otras iglesias para contar su historia.</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery1-2.jpg',
          alt: 'César con una biblia',
          index: '02',
          caption: `<p>César cree que "el cristianismo es para todos".</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote: `Recibo mensajes de los pastores que me dicen que vivo en pecado, que no debería predicar o hablar la palabra de Dios porque soy indocumentado.`,
      cite: 'Cesar'
    },
    {
      template: 'textModule',
      text: `<p>
                Después de que lo atraparon destrozando una casa con un amigo, César tuvo un golpe de suerte: en lugar de presentar cargos, los propietarios, una pareja mayor, le pidieron que arreglara las cosas ayudándoles con el trabajo de jardinería. Esto condujo a una amistad poco probable. Pronto César empezó a ir a la iglesia con ellos. Como él dice: "Así fue como me introdujeron al cristianismo". Y sigue asistiendo a la iglesia hoy en día.
            </p>
            <p>
                Su fe ha sido puesta a prueba a lo largo de los años. Su comunidad cristiana lo ha apoyado y criticado: los miembros de la iglesia se comprometieron a pagar su colegiatura en un colegio bíblico, mientras que otros le escribieron en privado para decirle que debería regresar a México. "Ellos decían: 'Oye, deberías regresar de la forma correcta. Estás viviendo en pecado'. Es como si mi propia religión me dijera no soy lo suficientemente bueno para ella".
            </p>
            <p>
                César no se siente intimidado. Hizo pública su historia de ser indocumentado en Estados Unidos, escribiendo y hablando para apoyar el programa de Acción Diferida para los Llegados en la Infancia (DACA), del cual es beneficiario. DACA ha permitido que César y otros miles que llegaron sin papeles a los Estados Unidos con sus padres, pudieran quedarse, trabajar y prosperar aquí. Aunque podría ser revocado en cualquier momento.
            </p>
            <p>
                César canaliza su incertidumbre diaria con una especie de motivación positiva, hablando regularmente sobre su situación y la inmigración en las iglesias que lo reciban. Jamás olvidará que él, alguna vez recibió ayuda y, guiado por su fe, trata de hacer lo mismo por los demás. "No creo que Dios me haya puesto en esta posición para poder despreciar a mi propia gente", dice. "Mi papel es ser un puente entre los hispanos y los estadounidenses".
            </p>`
    },
    {
      template: 'imageGalleryModule',
      images: [
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery2-1.jpg',
          alt: 'César y sus amigos disfrutan de una bebida al aire libre en una tarde de verano',
          index: '01',
          caption: `<p>César disfrutando de una noche de verano con amigos.</p>`
        },
        {
          width: 500,
          height: 751,
          url: 'assets/images/story/story-cesar/cesar-image-gallery2-2.jpg',
          alt: 'César en un bar con una gran bandera estadounidense detrás de él',
          index: '02',
          caption: `<p>César describe: "Cuando manejo con las ventanas abajo o, simplemente, al tomar un té dulce en un frasco, me siento tan estadounidense, como cualquier otra persona".</p>`
        }
      ]
    },
    {
      template: 'quoteModule',
      quote:
        'Me siento como un aficionado de fútbol americano de Alabama. Tienen boletos para toda la temporada, su habitación está llena de cosas de Bama, pero la mayoría de ellos no tienen un título universitario de Alabama. Lo tengo todo en Estados Unidos: tengo una casa, tengo un auto, un trabajo excelente, pero simplemente no tengo ese diploma, esa ciudadanía.',
      cite: 'Cesar'
    },
    {
      template: 'textModule',
      text: `<p>Ni César ni ningún otro beneficiario de DACA saben qué pasará con el programa o sus vidas, y sus hogares, sus empleos y sus familias en Estados Unidos. Mientras tanto, César finalmente obtuvo su licencia, lo que le permitió manejar legalmente. "Tan pronto como la conseguí, manejé para ver a un amigo en Florida, a seis horas de distancia, y solo recuerdo que lloré como un bebé y sentí todo el peso que estaba cargando durante ese tiempo tan largo, se desvanecía con cada milla recorrida".</p>`
    },
    {
      template: 'donateModule',
      title: 'Haz una donación',
      subtitle: 'Unete a nuestra causa',
      body: `<p> 
                Todos los problemas que contribuyen a nuestra actual crisis de inmigración están interconectados. Tus historias nos inspiran a seguir tomando una postura: cuando nuestra comunidad de viajeros y conductores sea amenazada, nosotros tomaremos las medidas pertinentes.  
                <br><br>
                En honor a César, nos sentimos honrados de apoyar a <a href="https://www.fwd.us/" target="_blank">FWD.us</a>, una organización política bipartidista que cree que las familias, las comunidades y la economía de los Estados Unidos prosperan cuando más personas pueden alcanzar su máximo potencial. FWD.us aboga por proteger los derechos de los beneficiarios de DACA, los titulares de TPS y los titulares de DED.
                <br><br>
                Por favor, únete a nosotros para apoyarlos a través del Fondo de Renovación de DACA.
             </p>`,
      cta: 'Haz una donación',
      url: 'http://bit.ly/FundDACA'
    },
    {
      template: 'nextStoryModule',
      id: 'story-shervin',
      title: `Los ochenta`,
      alt: 'Shervin sentado en su carro',
      location: 'San Jose, CA',
      description: 'Después de la revolución iraní',
      imageSize1URL: 'assets/images/carousel/carousel-image-shervin-1280.jpg',
      imageSize2URL: 'assets/images/carousel/carousel-image-shervin-1920.jpg',
      featureVideoURL:
        'https://player.vimeo.com/external/344699878.sd.mp4?s=7ed73e4052345395d4a29f2d53f2ff61fe2d38de&profile_id=165',
      rolloverVideoURL:
        'https://player.vimeo.com/external/344700809.sd.mp4?s=03f44317b238802fa65f0cb857694e4651bb0be3&profile_id=165'
    }
  ]
};

export default {en, es};

